<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de posição de estoque">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/relatorio-posicao-estoque/List'

export default {
    components: {List},
}
</script>